import React from 'react'

const Conttact = () => {
  return (
    <div name='contact' className='w-full h-screen bg-[#230552] flex justify-center items-center p- py-[400px]'>
        <form method='POST' action="https://getform.io/f/7017f064-7a06-4415-b122-199887ea2fc8" className='flex flex-col max-w-[600px] w-full py-36'>
            <div className='pd-8'>
                <p className='text-4xl font-bold inline border-b-4 border-blue-600 text-gray-300'>Contact</p>
                <p className='py-4 text-gray-300'> Submit the form below or shoot me an email - metrogan94@gmail.com</p>
            </div>

            <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
            <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
            <textarea className='bg-[#ccd6f6] p-2' name="message" id="" cols="30" rows="10" placeholder='Message'></textarea>
            <button className='text-white border-2 hover:bg-blue-600 px-4 py-3 my-8 mx-auto flex items-center'>Let's Collaborate</button>
        </form>
    </div>
  )
}

export default Conttact